/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartRangeBar = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-chart-range-bar_svg__st0{fill:currentcolor}'}</style>
    <path className="ico-chart-range-bar_svg__st0" d="M4 20V2H2v20h20v-2z" />
    <path
      className="ico-chart-range-bar_svg__st0"
      d="M9 11h2v8H9zm3-3h2v6h-2zm3-4h2v12h-2zm3-1h2v4h-2zM6 8h2v5H6z"
    />
  </Icon>
);
export { SvgChartRangeBar as ChartRangeBar };
